import { nextTick, onBeforeUnmount, onDeactivated, ref, watch } from 'vue';
import { fitFloatingPanel, trackFloatingAnchor } from '@/utils/floatingPanel';

// Follow the trigger, keyboard viewport and changes to the panel's contents.
export const useFloatingPanel = ({ open, anchor, panel, enabled = () => true, width = 240, align = 'end' }) => {
	const style = ref({});
	let stopTracking;
	let observer;
	const stop = () => {
		stopTracking?.();
		stopTracking = undefined;
		observer?.disconnect();
		observer = undefined;
	};
	const position = () => {
		if (!open.value || !enabled() || !anchor.value || !panel.value) return;
		const rect = anchor.value.getBoundingClientRect();
		const panelWidth = width === 'max-content' ? panel.value.offsetWidth : width;
		const nextStyle = fitFloatingPanel({ top: rect.top, bottom: rect.bottom, left: align === 'start' ? rect.left : rect.right - panelWidth }, {
			width: panelWidth, height: width === 'max-content' ? panel.value.offsetHeight : panel.value.scrollHeight,
		});
		style.value = { ...nextStyle, ...(width === 'max-content' ? { width } : {}) };
	};
	watch([open, anchor, panel, enabled], async () => {
		stop();
		if (!open.value || !enabled()) return;
		await nextTick();
		if (!open.value || !anchor.value?.isConnected || !panel.value) return;
		stop();
		stopTracking = trackFloatingAnchor(anchor.value, position);
		observer = new ResizeObserver(position);
		observer.observe(panel.value);
	}, { flush: 'post' });
	onBeforeUnmount(stop);
	onDeactivated(stop);
	return style;
};
